import {
  ExtendedRadioButtonProps,
  RadioStackProps,
} from '@components/ui/radio-stack';
import { TextStyle } from '@shopify/polaris';
import { FunctionComponent } from 'react';
import DropdownList from '../../dropdown-list';
import { countries } from './countries';

const countryOptions: ExtendedRadioButtonProps[] = Object.entries(
  countries,
).map(([code, name]) => ({
  id: code,
  label: `${name} (${code})`,
  name: code,
}));

export type CountryDropdownProps = Partial<
  Pick<RadioStackProps, 'onToggle' | 'initialState'>
>;

const CountryDropdown: FunctionComponent<CountryDropdownProps> = (params) => {
  const { initialState = countries.US, onToggle } = params;

  return (
    <DropdownList
      activator={<TextStyle>{initialState}</TextStyle>}
      radioStackProps={{
        buttons: countryOptions,
        initialState: initialState.toUpperCase(),
        onToggle,
      }}
    />
  );
};

export default CountryDropdown;
